export const ChevronLeftSvgIcon = () => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.5247 15.8333C11.2726 15.8341 11.0336 15.7208 10.8747 15.5249L6.84973 10.5249C6.59697 10.2174 6.59697 9.77409 6.84973 9.46659L11.0164 4.46659C11.3109 4.11221 11.837 4.0637 12.1914 4.35826C12.5458 4.65281 12.5943 5.17887 12.2997 5.53326L8.57473 9.99992L12.1747 14.4666C12.3828 14.7164 12.4266 15.0643 12.287 15.3579C12.1474 15.6515 11.8498 15.8371 11.5247 15.8333Z"
      fill="currentColor"
    />
  </svg>
);
